import Base, { KLinkText } from './Base';

export default class KLink {
  static Base = Base;

  static Text = KLinkText;
}
